import { defineComponent as _defineComponent } from 'vue'

import type { MaterialV1, NewMaterialV1 } from '@ilteducation/content-registry-types';
import MaterialsForm from './Form.vue';
import useMaterialUtil from './use-material-util';

type Props = {
  id?: string;
  title: string;
  item?: MaterialV1;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: MaterialV1;
}

const { newMaterial } = useMaterialUtil();

const Material: NewMaterialV1 = newMaterial();

let cloned: NewMaterialV1 | undefined;
if (props?.item) {
  const { id, createdAt, lastUpdatedAt, activeVersion, file, ...rest } = props.item;
  cloned = rest;
}
const defaultMaterial = cloned ?? Material;
const isClone = !!cloned;

return { __sfc: true,newMaterial, Material, props, cloned, defaultMaterial, isClone, MaterialsForm }
}

})